import {API_POST_METHOD, API_PUT_METHOD, API_GET_METHOD} from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';
import { axiosLabAPI } from 'services/axios';

export async function fetchListOfPathologists(){
    let results = [];
    try{
		const content = {
			method: API_GET_METHOD,
			url: 'settings/pathologists',
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			results = data.RECORDS;
		}
        return results;
	}
	catch(e) {
		showMessage(e);
	}

}

export async function fetchPathologist(payload){
    let results = [];
    try{
		const content = {
			method: API_GET_METHOD,
			url: 'settings/pathologists',
            params: {p_pathologist_id: payload}
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			results = data.RECORDS.at(0);
		}
        return results;
	}
	catch(e) {
		showMessage(e);
	}
}

export async function createPathologist(payload){
	let result = {};
	try{
		const content = {
			method: API_POST_METHOD,
			url: 'settings/pathologists',
			data: {
				p_first_name: payload.pathologistFirstName,
				p_middle_name: payload.pathologistMiddleName,
				p_last_name: payload.pathologistLastName,
				p_degree: payload.pathologistDegree,
				p_prefix: payload.pathologistPrefix,
				p_suffix: payload.pathologistSuffix,
				p_license_no: payload.pathologistLicenseNo,
				p_validity: payload.pathologistValidity,
				p_is_active: payload.isActive,
			},
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;
		result = data.RECORDS.at(0) || {};
	}
	catch(e) {
		showMessage(e);
	}

	return result;
}

export async function updatePathologist(payload){
	let result = {};
	try{
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/pathologists',
			data: {
				p_id: payload.pathologistID,
				p_first_name: payload.pathologistFirstName,
				p_middle_name: payload.pathologistMiddleName,
				p_last_name: payload.pathologistLastName,
				p_degree: payload.pathologistDegree,
				p_prefix: payload.pathologistPrefix,
				p_suffix: payload.pathologistSuffix,
				p_license_no: payload.pathologistLicenseNo,
				p_validity: payload.pathologistValidity,
				p_is_active: payload.isActive,
			},
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		result = data.RECORDS.at(0) || {};
	}
	catch(e) {
		showMessage(e);
	}

	return result;
}	